import { ObjectKeyMap } from './objectify';

/**
 *
 * @param obj Any object with string properties
 * @returns An object of properties mapped to themselves
 */
export const SelfMapObjectKeys = <T extends { [key: string]: any }>(obj: T): ObjectKeyMap<T> =>
	Object.keys(obj).reduce(
		(obj, key) => ({
			...obj,
			[key]: key,
		}),
		{} as ObjectKeyMap<T>,
	);
